import { GLTFExporter } from "three/examples/jsm/exporters/GLTFExporter";

export function exportGLB(object3D) {
  return new Promise((resolve, reject) => {
    const exporter = new GLTFExporter();
    exporter.parse(
      object3D,
      result => {
        if (result instanceof ArrayBuffer) {
          // ✅ Binary GLB formatı
          const blob = new Blob([result], { type: "model/gltf-binary" });
          resolve(blob);
        } else {
          // ⚠️ Fallback: JSON GLTF formatı (rare case, or fallback)
          const blob = new Blob(
            [JSON.stringify(result)],
            { type: "application/json" }
          );
          resolve(blob);
        }
      },
      {
        binary: true,
        onlyVisible: true,
        embedImages: true,
        includeCustomExtensions: false,
      }
    );
  });
}